import { useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useAuth } from '../../../auth/hooks/useAuth';
import { userApi } from '../api/userApi';
import { TRootStackParamList } from 'app/types/navigation';
import { Telemetry } from 'app/services/telemetry/Telemetry';

type LegalNavigationProp = NativeStackNavigationProp<TRootStackParamList>;

export const useLegalContent = () => {
  const { meData } = useAuth();
  const navigation = useNavigation<LegalNavigationProp>();
  const [isLoading, setIsLoading] = useState<string | null>(null);

  // TECHDEBT
  // Issue: https://app.clickup.com/t/86c8fp9eg
  // Description: Direct API call without React Query - should use useQuery for caching and better UX
  const fetchLegalContent = async (
    type: 'terms_and_conditions' | 'privacy_policy',
  ) => {
    try {
      setIsLoading(type);
      if (!meData?.organization?.id) {
        throw new Error('Organization ID not found');
      }
      const data = await userApi.getLegalContent(
        meData.organization.id,
        type
      );
      navigation.navigate('PdfDocumentPage', { pdfUrl: data.url });
    } catch (error) {
      Telemetry.error(error as Error, {
        event: 'user.legal.fetch_failed',
        domain: 'user',
        context: { source: 'useLegalContent', type },
      });
    } finally {
      setIsLoading(null);
    }
  };

  const handleTerms = () => {
    if (isLoading === null) {
      fetchLegalContent('terms_and_conditions');
    }
  };

  const handlePrivacy = () => {
    if (isLoading === null) {
      fetchLegalContent('privacy_policy');
    }
  };

  return {
    isLoading,
    handleTerms,
    handlePrivacy,
  };
};
